module.exports = __webpack_public_path__ + "static/08-1-4b024002beeccf43a1686e80b5151b0b.jpg";